/* eslint-disable indent */
import React from 'react'

import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Tabs,
    Tab,
    Typography,
    Box,
} from '@material-ui/core'

import './index.scss'

function TabPanel({
  children, value, index, ...other
}) {
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

class NlpViewer extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            value: 0,
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e, newValue) {
        this.setState({ value: newValue })
    }

    render() {
        const getClsResponse = () => {
            let parsedResponse
            try {
                parsedResponse = JSON.stringify(
                    JSON.parse(this.props.classifierResponse),
                    null,
                    2
                )
            } catch (e) {
                console.log('Error getClsResponse - ', e)
                parsedResponse = ''
            }

            return parsedResponse
        }
        const getOldClsResponse = () => {
            let parsedResponse
            try {
                parsedResponse = JSON.stringify(
                    JSON.parse(this.props.oldClassifierResponse),
                    null,
                    2
                )
            } catch (e) {
                console.log('Error getClsResponse - ', e)
                parsedResponse = ''
            }

            return parsedResponse
        }

        return (
            <div className='NlpViewer'>
                <Dialog
                    open={true}
                    onClose={() => {
                        this.props.nlpViewerClose()
                    }}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                >
                    <Tabs
                        style={{ justifyContent: 'center' }}
                        value={this.state.value}
                        onChange={this.handleChange}
                        aria-label='simple tabs example'
                    >
                        <Tab
                            style={{ fontSize: '12px' }}
                            label='Classifier response'
                            {...a11yProps(0)}
                        />
                        {this.props.oldClassifierResponse && (
                            <Tab
                                style={{ fontSize: '12px' }}
                                label='Original Classifier response'
                                {...a11yProps(1)}
                            />
                        )}
                    </Tabs>
                    <TabPanel value={this.state.value} index={0}>
                        <DialogContent>
                            <DialogContentText id='alert-dialog-description'>
                                <pre className='cls-json'>
                                    {getClsResponse()}
                                </pre>
                            </DialogContentText>
                        </DialogContent>
                    </TabPanel>
                    <TabPanel value={this.state.value} index={1}>
                        <DialogContent>
                            <DialogContentText id='alert-dialog-description'>
                                <pre className='cls-json'>
                                    {getOldClsResponse()}
                                </pre>
                            </DialogContentText>
                        </DialogContent>
                    </TabPanel>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                this.props.nlpViewerClose()
                            }}
                            color='primary'
                            autoFocus
                        >
                            Got it
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default NlpViewer
